import React from "react"
import { Header } from "semantic-ui-react";


export const FieldHeader: React.FC<{ content?: string }> = (props) => {
    return (
        <div className="ui header sub">{props.content || props.children}</div>
    );
};